var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFmFederatedStatesofMicronesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_18381)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0547 0H-15.1853V45.12H75.0547V0Z",
    fill: "#6797D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9522 10.8393L32.8074 12.7957L31.7147 9.63203L34.5787 7.67565H31.0449L29.9522 4.51196L28.8594 7.68446H25.3344L28.1897 9.63203L27.0969 12.7957M29.9522 34.3687L32.8074 32.4123L31.7147 35.5848L34.5787 37.5324H31.0449L29.9522 40.6961L28.8594 37.5236L25.3344 37.5324L28.1897 35.576L27.0969 32.4123M43.6997 24.2696L45.8587 26.9662L45.7354 23.6175L49.04 22.5864L45.656 21.5553L45.5415 18.2066L43.5763 20.9208L40.1923 19.881L42.3602 22.5864L40.3862 25.2918M16.2223 24.2608L14.0544 26.9662L14.1778 23.6175L10.8731 22.5864L14.2571 21.5553L14.3717 18.2066L16.3369 20.9208L19.7209 19.881L17.553 22.5864L19.527 25.2918",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_18381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmFederatedStatesofMicronesia);
export default __webpack_public_path__ + "static/media/fm Federated States of Micronesia.9de0c98a9bf31a3ffb44607e7835eaf3.svg";
export { ForwardRef as ReactComponent };